module.exports = window["MaterialUI"].CircularProgress;